import { render } from "./IconArrowRightLeft.vue?vue&type=template&id=ec717de8"
const script = {}
script.render = render

export default script